// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"218d6d67","66":"bc7ba57b","163":"a5d95d16","256":"a5d95d16","456":"a5d95d16","765":"9637d909","819":"218d6d67"}[chunkId] + ".chunk.css";
};